import { Archivo, Barlow, Public_Sans, Jost, Roboto } from "next/font/google";

const archivo = Archivo({ weight: ["400", "600", "700"], subsets: ["latin"] });
const publicSans = Public_Sans({ weight: ["400", "600", "700"], subsets: ["latin"] });
const jost = Jost({ weight: ["400", "600", "700"], subsets: ["latin"] });
const barlow = Barlow({ weight: ["400", "600", "700"], subsets: ["latin"] }); // error in subsets
const roboto = Roboto({ weight: ["400", "500", "700"], subsets: ["latin"] }); // error in subsets

export const useGetSiteFont = (fontFamily: string) => {
  const fontsIndex: { [key: string]: string } = {
    Archivo: archivo.className,
    "Public Sans": publicSans.className,
    Jost: jost.className,
    Barlow: barlow.className,
    Roboto: roboto.className,
  };

  return fontsIndex[fontFamily];
};
